import React from 'react';
import { Select, MenuItem, Stack } from '@mui/material';
import { PAGES, CustomizerPage } from './constants';
import { FormValues } from './types';
import Homepage from './Homepage';
import { useFormContext } from 'react-hook-form';
import General from './General';
import AboutPage from './AboutPage';
import { useTranslation } from 'services/localization';
import { getPageTitle } from './utils';

const CustomizerEditorPanel = () => {
	const { t } = useTranslation();
	const { setValue, watch } = useFormContext<FormValues>();
	const selectedPage = watch('selectedPage');

	const renderPage = (selectedPage: CustomizerPage) => {
		switch (selectedPage) {
			case PAGES.general:
				return <General />;
			case PAGES.home:
				return <Homepage />;
			case PAGES.about:
				return <AboutPage />;
			default:
				return undefined;
		}
	};

	return (
		<>
			<Select
				value={selectedPage}
				onChange={(e) =>
					setValue('selectedPage', e.target.value as CustomizerPage, { shouldDirty: false })
				}
				variant="outlined"
				fullWidth
				MenuProps={{
					style: { zIndex: 9999 },
				}}
			>
				{Object.values(PAGES).map((page) => (
					<MenuItem key={page} value={page}>
						{getPageTitle(page, t)}
					</MenuItem>
				))}
			</Select>
			<Stack spacing={2} mt={2}>
				{renderPage(selectedPage)}
			</Stack>
		</>
	);
};

export default CustomizerEditorPanel;
